/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'help': {
    width: 26.6,
    height: 18.6,
    viewBox: '0 0 26.6 18.6',
    data: '<path pid="0" d="M24.2 1.9V.3L22.399.1C21.8 0 21.2 0 20.6 0c-1.5 0-3 .2-4.399.6-1 .3-2 .6-2.9 1.1-.9-.5-1.9-.8-2.9-1.1C9 .2 7.5 0 6 0c-.6 0-1.2 0-1.8.1L2.3.3v1.6H0v15.4h10.8c.5.2 2.5 1.3 2.5 1.3s2-1.1 2.5-1.3h10.8V1.9h-2.4zM2.3 16.2H1.2V3h1.1v13.2zm10-.5c-1.9-.9-4-1.4-6.3-1.4-.5 0-1.1 0-1.6.1V2.1C4.9 2 5.4 2 6 2c2.2 0 4.4.5 6.3 1.4v12.3zm9.9-1.301c-.5-.1-1-.1-1.601-.1-2.2 0-4.399.5-6.3 1.4V3.4c1.9-.9 4-1.4 6.3-1.4.501 0 1.101 0 1.601.1v12.299zm3.199 1.801H24.2V3h1.199v13.2z"/>'
  }
})
